import React from 'react';

import { useProfileState, useProfileActions } from './ProfileContext';

import Divider from '../../Shared/UI/Divider/components/Divider';
import Button from '../../Shared/UI/Button/components/Button';
import PlusIcon from '../../Shared/UI/PlusIcon/components/PlusIcon';
import ProfileUserSkill from './ProfileUserSkill';
import SkillsModal from './SkillsModal';

import styles from './ProfileUserSkills.module.scss';

const ProfileUserSkills = () => {
  const state = useProfileState();
  const { openUserSkillsModal } = useProfileActions();

  if (state.loading) {
    return (
      <section id={styles.userSkillsSection}>
        <Divider />
        <div id={styles.userSkillsLoading} />
      </section>
    );
  }

  if (state?.user?.isAuthenticatedUser && state?.user?.skills?.length) {
    return (
      <>
        <section id={styles.userSkillsSection}>
          <Divider />
          <div id={styles.userSkillsSectionHeader}>
            <h2>
              Skills
            </h2>
            <Button
              variant="ghost"
              icon={<PlusIcon />}
              iconOnly
              aria-label="Add Skill"
              onClick={() => {
                openUserSkillsModal();
              }}
            />
          </div>
          <div id={styles.userSkills}>
            {state.user?.skills?.map((skill) => {
              return <ProfileUserSkill key={skill.id} skill={skill} />;
            })}
          </div>
        </section>
        <SkillsModal />
      </>
    );
  }

  if (state?.user?.isAuthenticatedUser && !state?.user?.skills?.length) {
    return (
      <>
        <section id={styles.userSkillsSection}>
          <Divider />
          <div id={styles.userSkillsSectionHeader}>
            <h2 className={styles.visibleOnlyToYou}>
              Skills
            </h2>
            <Button
              variant="ghost"
              icon={<PlusIcon />}
              iconOnly
              aria-label="Add Skill"
              onClick={() => {
                openUserSkillsModal();
              }}
            />
          </div>
          <p className={styles.visibleOnlyToYou}>
            This section is currently only visible to you since you have not claimed any skills to display yet.
          </p>
        </section>
        <SkillsModal />
      </>
    );
  }

  if (!state?.user?.isAuthenticatedUser && state?.user?.skills?.length) {
    return (
      <>
        <section id={styles.userSkillsSection}>
          <Divider />
          <h2>
            Skills
          </h2>
          <div id={styles.userSkills}>
            {state.user?.skills?.map((skill) => {
              return <ProfileUserSkill key={skill.id} skill={skill} />;
            })}
          </div>
        </section>
      </>
    );
  }

  if (!state?.user?.isAuthenticatedUser && !state?.user?.skills?.length) {
    return null;
  }
};

export default ProfileUserSkills;
